<template>
  <div class="index">
    <navi :activeIndex="2"></navi>
    <div class="container">
      <div>
        <div class="title1">VR学车训练成果</div>
        <div class="c1">
          <img class="left" src="@/assets/alsj_01.jpg" alt="">
          <div class="right">
            <div>市区室内VR练车，</div>
            <div>教会学员 80% 技能。</div>
            <div>场地实操演练 , 帮助巩固驾驶技能</div>
            <div>
              可以节省教练工作量
              <span class="t1">80%</span>
            </div>
            <div class="t2">
              <span class="t1">5000+</span>用户体验，三年实测;
            </div>
            <div>VR学员驾考通过率</div>
            <div>高于传统教学</div>
          </div>
        </div>
      </div>
      <div class="c1">
        <div class="title1 t4">VR学车案例</div>
        <div>
          <img class="left" src="@/assets/alsj_02.jpg" alt="">
          <div class="right">
            <div>2016 年开始在福州康达驾校运营 VR 学车，3 年运营，大大节省了驾校的场地成本、车辆损耗、油费成本等。</div>
            <div class="t2">2017 年驾校与警察学院进行合作，警察学院学生对 VR 学车热情高涨，学习速度快，培养了近 1000 名警察学院的学生。</div>
          </div>
        </div>
      </div>
      <div class="c2 title1">对比数据：
        <span class="t3">减少60%运营费用·减少80%驾校用地</span>
      </div>
      <img class="img1" src="@/assets/sj.png" alt="">
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "CaseData",
  components: {
    Navi
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  /* box-shadow: 0px 0px 6px #999; */
  width: 1380px;
  height: 500px;
  margin: 40px auto;
}

.c1 {
  height: 530px;
}

.title1 {
  color: #333;
  font-size: 40px;
  text-align: left;
  margin-bottom: 40px;
}

.left {
  float: left;
}

.right {
  display: inline-block;
  text-align: left;
  font-size: 26px;
  line-height: 42px;
  color: #666;
  width: 500px;
}

.t1 {
  color: #ea6841;
  font-size: 45px;
}

.t2 {
  margin-top: 30px;
}

.c2 {
  margin-top: 200px;
  margin-left: 30px;
}

.t3 {
  color: #ea6841;
  font-size: 40px;
}
.img1 {
  margin-bottom: 100px;
}
@media only screen and (max-width: 800px) {
  .container {
    width: auto;
    margin: 60px 30px;
  }
  .right {
    display: block;
    margin-top: 20px;
  }
  .title1 {
    font-size: 32px;
  }
  img {
    float: none !important;
    width: 100%;
    display: block;
  }
  .c1 {
    height: auto;
  }
  .c2 {
    margin: 60px 0px;
  }
  .t3 {
    font-size: 32px;
  }
  .t4 {
    margin-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CaseData.vue